import React from "react";
import "./login.css"
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setUserDetails, resetUserDetails } from "../../store/userdetails";
import axios from "axios";
import { useUserActions } from "../../hooks/user.actions";

function Login({quit}){

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const [ user, setUser ] = React.useState({
        "username":"",
        "password": ""
    })

    const userActions = useUserActions()

    

    function handleChange(event){

        const {name, value} = event.target

        setUser(prevdata => ({

            ...prevdata,
            [name]: value
            })
        )
    }
    

    const handleSubmit = (e) =>{
        e.preventDefault()
        userActions.login(user)
            .catch((error) => console.error(error))

        dispatch(setUserDetails(JSON.parse(localStorage.getItem("user"))))
        navigate("/dashboard")
    }



    return(
        <div className="cont">
        
            {typeof(quit)==="function" && <div className="exit--button" onClick={quit}><i className="fa-solid fa-xmark"></i></div>}

            <div className="form--container--login">
                <form className="forms--login" onSubmit={handleSubmit}>
                    
                    <label htmlFor="username">Username</label>
                    <input value={user.username} onChange={(event)=>handleChange(event)} name="username" type="text" className="login-input--box" id="username"/>
                    <label htmlFor="password">Password</label>
                    <input value={user.password} onChange={(event)=>handleChange(event)} name="password" type="password" className="login-input--box" id="password"/>

                    <button className="submit--button" >Login
                        <span></span><span></span><span></span><span></span>
                    </button>

                    <h3>You don't Have an Account?<small><Link to="/register">You can register here</Link></small></h3>
                
                </form>
                <hr></hr>
                <div className="form--illustration"></div>
            </div>
        </div>
    )
}

export default Login;